var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('PageTitle', [_vm._v("UI")]), _vm._m(0), _c('hr'), _vm._m(1), _c('hr'), _vm._m(2), _c('hr'), _c('div', {
    staticClass: "s-space-y-3"
  }, [_c('Input', {
    attrs: {
      "label": "default",
      "name": "default",
      "placeholder": "default"
    },
    model: {
      value: _vm.text,
      callback: function callback($$v) {
        _vm.text = $$v;
      },
      expression: "text"
    }
  }), _c('Input', {
    attrs: {
      "label": "error",
      "name": "error",
      "placeholder": "error",
      "error": "error"
    },
    model: {
      value: _vm.text,
      callback: function callback($$v) {
        _vm.text = $$v;
      },
      expression: "text"
    }
  }), _c('Input', {
    attrs: {
      "label": "help",
      "name": "help",
      "placeholder": "help",
      "help": "help"
    },
    model: {
      value: _vm.text,
      callback: function callback($$v) {
        _vm.text = $$v;
      },
      expression: "text"
    }
  }), _c('Input', {
    attrs: {
      "label": "disabled",
      "name": "disabled",
      "placeholder": "disabled",
      "disabled": ""
    },
    model: {
      value: _vm.text,
      callback: function callback($$v) {
        _vm.text = $$v;
      },
      expression: "text"
    }
  })], 1), _c('hr'), _vm._m(3)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-space-y-3"
  }, [_c('div', {
    staticClass: "s-text-caption"
  }, [_vm._v("caption")]), _c('div', {
    staticClass: "s-text-xl"
  }, [_vm._v("xl")]), _c('div', {
    staticClass: "s-text-base"
  }, [_vm._v("base")]), _c('div', {
    staticClass: "s-text-sm"
  }, [_vm._v("sm")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-space-y-3"
  }, [_c('div', {
    staticClass: "s-font-bold"
  }, [_vm._v("bold")]), _c('div', {
    staticClass: "s-font-semibold"
  }, [_vm._v("semibold")]), _c('div', {
    staticClass: "s-font-medium"
  }, [_vm._v("medium")]), _c('div', {
    staticClass: "s-font-normal"
  }, [_vm._v("normal")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-space-y-3"
  }, [_c('div', {
    staticClass: "s-text-secondary"
  }, [_vm._v("secondary")]), _c('div', {
    staticClass: "s-text-warning"
  }, [_vm._v("warning")]), _c('div', {
    staticClass: "s-text-danger"
  }, [_vm._v("danger")]), _c('div', {
    staticClass: "s-text-black"
  }, [_vm._v("black")]), _c('div', {
    staticClass: "s-text-gray-darker"
  }, [_vm._v("gray-darker")]), _c('div', {
    staticClass: "s-text-gray-dark"
  }, [_vm._v("gray-dark")]), _c('div', {
    staticClass: "s-text-gray"
  }, [_vm._v("gray")]), _c('div', {
    staticClass: "s-text-gray-light"
  }, [_vm._v("gray-light")]), _c('div', {
    staticClass: "s-text-gray-lighter"
  }, [_vm._v("gray-lighter")]), _c('div', {
    staticClass: "s-text-white"
  }, [_vm._v("white")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-space-y-3"
  }, [_c('button', {
    staticClass: "s-btn s-btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("primary")]), _c('button', {
    staticClass: "s-btn s-btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("primary")]), _c('button', {
    staticClass: "s-btn s-btn-secondary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("second")]), _c('button', {
    staticClass: "s-btn s-btn-secondary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("second")]), _c('button', {
    staticClass: "s-btn s-btn-secondary s-btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("second sm")]), _c('button', {
    staticClass: "s-btn s-btn-secondary s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("second sm")])]);
}]

export { render, staticRenderFns }